<template>
    <img src="../../../public/logo.png" alt="Logo" />
</template>
